<template>
  <!-- 我的收藏 -->
  <div class="collection-base">
    <div class="coll_list-wrap" v-if="collectionList.length">
      <div class="coll_list-bl">
        <div class="coll-item" v-for="item in collectionList" :key="item.id" @click="gotoDetail(item)">
          <div class="coll_cover">
            <img :src="item.video_cover" />
			<div class="memberTag_right" v-if="item.member_type == 2">会员专享</div>
          </div>
          <div class="coll_info">
            <div class="coll_title">{{ item.title }}</div>
            <div class="coll_info-btm-wrap">
              <span class="speaker_name">{{ item.speaker.name }}</span>
              <span class="collection_type">{{ item.collection_type | formatCollType }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
    <div class="empty-bl" v-else>
      暂无数据
    </div>
  </div>
  <!-- 我的收藏END -->
</template>

<script>
import requestApi from '@/service';

import configFields from '@/utils/configFields';
const { COLLECTION_TYPE } = configFields;
export default {
  data() {
    return {
      collectionList: [], // 收藏列表
      total: 0,
      pageNum: 1,
      pageSize: 6,
    };
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  filters: {
    formatCollType(type) {
      return COLLECTION_TYPE[type].label;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * @description: 获取收藏列表
     */
    getData() {
      requestApi('/v3/api/v1/collection/change/', {
		type:1,
		collection_type:1,
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(res => {
		  if (this.pageNum === 1) {
		    this.collectionList = res.items;
		    this.total = res.total;
		  } else {
		    this.collectionList.push(...res.items);
		  }
	  })
    },
    /**
     * @description: 收藏加载更多
     */
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    gotoDetail(data) {

      const type = COLLECTION_TYPE[data.collection_type].type;
      let options = {};
      switch (type) {
        case 'speech':
		options = {
		  path: `/${type}/detail`,
		  query: {
		    id: data.id,
			videotype:data.video_type,
		  },
		};
		break;
        case 'record':
          options = {
            path: `/${type}/detail`,
            query: {
              id: data.id,
            },
          };
          break;
        case 'zhiya':
        case 'wanxiang':
          options = {
            path: `/${type}/detail`,
            query: {
              id: data[`${type}_id`],
              episodeId: data[`${type}_video_id`],
            },
          };
          if (type === 'wanxiang') {
            options.query.isColumn = 0;
          }
          break;
        default:
          break;
      }
      this.$router.push(options);
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-base {
  min-height: 100%;
  height: 100%;
}
.coll_list-bl {
  display: grid;
  grid-template-columns: repeat(3, 33.3%);
  grid-template-rows: 260px;
  grid-row-gap: 20px;
  grid-column-gap: 10px;
  padding: 30px;
  min-height: 100%;
  background: $C1;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  .coll-item {
    transition: all 0.3s linear;
	position: relative;
    border: 1px solid $C11;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    .coll_info {
      padding: 20px 15px;
    }
    .coll_cover {
      height: 160px;
    }
    .coll_title {
      color: $C6;
      font-size: 16px;
      line-height: 17px;
      font-family: HYXinRenWenSongW;
    }
    .coll_info-btm-wrap {
      font-size: 12px;
      line-height: 12px;
      color: #666;
      font-weight: 300;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
    }
    &:hover {
      // box-shadow: 3px 3px 6px $A5;
      box-shadow: 6px 6px 20px rgba(0, 0, 0, 0.15);
    }
  }
}
.empty-bl {
  width: 100%;
  height: 100%;
  background: $C1;
  text-align: center;
  padding-top: 15%;
  box-sizing: border-box;
  color: $C5;
  letter-spacing: 2px;
  font-weight: 300;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
}
</style>
